import DOMPurify from 'dompurify';

// Опции санитайзинга совпадают с теми, что используют компоненты ДЗ
// (HomeworkAttempt.vue / Homework.vue), чтобы поведение было единым.
const SANITIZE_OPTIONS = {
	USE_PROFILES: { html: true },
	ADD_ATTR: ['target', 'rel', 'class', 'style', 'data-linktype', 'data-cke-tooltip-text'],
	FORBID_TAGS: ['style', 'script']
};

// Фабрика регулярки на каждый вызов: глобальный флаг хранит lastIndex,
// поэтому переиспользовать один инстанс между вызовами нельзя.
function urlRegex() {
	return /(https?:\/\/[^\s<]+|www\.[^\s<]+)/gi;
}

const TRAILING_PUNCT = /[.,;:!?)\]}'"»]+$/;

function escapeHtml(str) {
	return String(str)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;');
}

// Превращает одно совпадение URL в <a>, отрезая хвостовую пунктуацию
// (точку/запятую/скобку), которая обычно не часть ссылки.
function anchor(rawUrl) {
	const trailing = (rawUrl.match(TRAILING_PUNCT) || [''])[0];
	const url = trailing ? rawUrl.slice(0, rawUrl.length - trailing.length) : rawUrl;
	const href = url.startsWith('www.') ? `https://${url}` : url;

	return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>${trailing}`;
}

// Плоский текст -> безопасный HTML с кликабельными ссылками.
// Используется для ответа студента, который хранится как обычный текст.
export function linkifyText(text) {
	const escaped = escapeHtml(text == null ? '' : text);
	const linked = escaped.replace(urlRegex(), match => anchor(match));

	return DOMPurify.sanitize(linked, SANITIZE_OPTIONS);
}

function linkifyNode(node) {
	Array.from(node.childNodes).forEach((child) => {
		if (child.nodeType === Node.TEXT_NODE) {
			const text = child.nodeValue || '';
			const escaped = escapeHtml(text);
			const linked = escaped.replace(urlRegex(), match => anchor(match));

			if (linked !== escaped) {
				const holder = document.createElement('span');
				holder.innerHTML = linked;
				child.replaceWith(...Array.from(holder.childNodes));
			}
		} else if (child.nodeType === Node.ELEMENT_NODE && child.tagName !== 'A') {
			// Уже существующие ссылки (например, из CKEditor) не трогаем.
			linkifyNode(child);
		}
	});
}

// Готовый HTML -> то же, но «голые» URL линкуются только в текстовых узлах,
// не ломая уже существующие <a>. Используется для ОС эксперта (control).
export function linkifyHtml(html) {
	const clean = DOMPurify.sanitize(html == null ? '' : html, SANITIZE_OPTIONS);
	const template = document.createElement('template');
	template.innerHTML = clean;
	linkifyNode(template.content);

	return DOMPurify.sanitize(template.innerHTML, SANITIZE_OPTIONS);
}
